import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomLoggerService {
  private originalConsoleError = console.error;
  private filesToIgnore: string[] = ['quill-better-table-plus.js']; // Add your files here

  constructor() {
    this.overrideConsoleError();
  }

  private shouldIgnore(message: string): boolean {
    return this.filesToIgnore.some(file => message.includes(file));
  }

  private overrideConsoleError() {
    console.error = (message?: any, ...optionalParams: any[]) => {
      if (typeof message === 'string' && this.shouldIgnore(message)) {
        return;
      }
      this.originalConsoleError.apply(console, [message, ...optionalParams]);
    };
  }
}
